import { isTagType } from "src/util/tagType";

/**
 * Whether a node in a tag-type explore sidebar section should show route-based
 * active styling. Scopes tag-type explore to the matching section only.
 *
 * @param {Object} node - Tree node
 * @param {String|null|undefined} activeTagId - Tag or tag-type id from the URL
 * @param {Object} tagTypesConfig - Workspace tag type config
 * @param {String} sectionTagTypeId - Tag type id for this sidebar section
 * @returns {Boolean}
 */
export const isTagRouteActive = (
  node,
  activeTagId,
  tagTypesConfig,
  sectionTagTypeId
) => {
  if (!activeTagId || !node?.id) {
    return false;
  }

  if (node.isTagTypeDesc) {
    return false;
  }

  if (isTagType(tagTypesConfig, activeTagId)) {
    if (node.tagValue?.id === activeTagId) {
      const tagType = node.tagValue.type ?? node.type;
      return tagType === sectionTagTypeId;
    }

    return sectionTagTypeId === activeTagId && node.id === activeTagId;
  }

  if (node.id !== activeTagId) {
    return false;
  }

  const tagType = node.tagValue?.type ?? node.type;
  if (tagType) {
    return tagType === sectionTagTypeId;
  }

  return false;
};
